import React from 'react';
import { defineMessages } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { Button } from '@sg/garnish';

export const OrderPlaybackGoBack = (props: OrderPlaybackGoBackProps) => {
  const { goBack, isDisabled } = props;

  return (
    <Button size="small" palette="kale" disabled={isDisabled} onPress={goBack}>
      <FormattedMessage {...messages.goBack} />
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  goBack: {
    defaultMessage: 'Go back',
    description: 'Bag | Order playback | Go back',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackGoBackProps = {
  isDisabled: boolean;
  goBack: () => void;
};
